module.exports = __webpack_public_path__ + "static/PHP_Wordpress-690aa2ba6ac3f7ccb5b115de0352f92f.jpg";